// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_fJ","advertDetailParameterList__header":"c-o_fK","advertDetailParameterList__list":"c-o_fL"};